<template>
<transition name="userdropdowntransition" >

<div class="user_dropdown"  v-click-away="hidePanel" v-if="show">
<div class="p-menu p-component p-input-filled" id="overlay_menu">
<h4 class="text-primary  mb-3 mt-3 pl-3 pr-3"><b>{{$store.state.languages.lang_phrases.bildirimler}}</b></h4>
<hr>
<br/><br/><br/><br/><br/><br/>
</div>

</div>
</transition>
</template>

<script>	
export default {

  name: 'UserNotifications',

  data () {
    return {
    	show:false,
    	items: [
                {
                    label:this.$store.state.auth.user.name,
                    items:[
						{
							separator: true,
							label:"separator"
						},
						{
						label: 'Profil',
							icon: 'pi pi-user',
							class:"test"
						},
						{
							label: 'Bildirimler',
							icon: 'pi pi-bell'
						}, 
                    ]
                },
                {
                    separator: true,
                    label:"separator"
                },
                {
                    label: 'Çıkış',
                    icon: 'pi pi-power-off',
                    command: () => {
                       this.logout()
                    }
                },
            ]
    }
  },
  methods:{
  	switchLanguage(event)
  	{
  		console.log(event.value);
  		let formdata = new FormData()      
      	this.silentSubmission(formdata,"user/set_pref_lang/"+event.value,this.afterswitchLanguage)
  	},
  	gotoProfile()
  	{
  		this.$router.push({ name: 'User', params: { id:"profile" } })
  	},
  	afterswitchLanguage(response)
  	{
  		this.getUserData()
  	},
  	hidePanel()
  	{
  		this.show = false
  	},
  	showPanel()
  	{
  		this.show = true
  	},
  }
};
</script>

<style lang="css" scoped>
</style>